import { render, staticRenderFns } from "./ProcessHistory.vue?vue&type=template&id=35c04ce8&"
import script from "./ProcessHistory.vue?vue&type=script&lang=js&"
export * from "./ProcessHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports